// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import AuditsService from './admin/audits/audits.service';

import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ActivateService from './account/activate/activate.service';
import RegisterService from './account/register/register.service';
import UserManagementService from '@/admin/user-management/user-management.service';

import LoginService from './account/login.service';
import AccountService from './account/account.service';

import '../content/scss/vendor.scss';
import AlertService from '@/shared/alert/alert.service';
import TranslationService from '@/locale/translation.service';
import ConfigurationService from '@/admin/configuration/configuration.service';

/* tslint:disable */

import UserInfoService from '@/entities/user-info/user-info.service';
import CompteClientService from '@/entities/compte-client/compte-client.service';
import EvenementService from '@/entities/evenement/evenement.service';
import ConferenceService from '@/entities/conference/conference.service';
import InscriptionService from '@/entities/inscription/inscription.service';
import ParticipationService from '@/entities/participation/participation.service';
import KiosqueService from '@/entities/kiosque/kiosque.service';
import KiosqueVisiteService from '@/entities/kiosque-visite/kiosque-visite.service';
import DocumentService from '@/entities/document/document.service';
import DocumentTelechargementService from '@/entities/document-telechargement/document-telechargement.service';
import AffRespCompteClientService from '@/entities/aff-resp-compte-client/aff-resp-compte-client.service';
import AffRespKiosqueService from '@/entities/aff-resp-kiosque/aff-resp-kiosque.service';
import UsagerService from '@/entities/usager/usager.service';
import AdresseService from '@/entities/adresse/adresse.service';
import SondageService from '@/entities/sondage/sondage.service';
import SondageQuestionService from '@/entities/sondage-question/sondage-question.service';
import SondageChoixService from '@/entities/sondage-choix/sondage-choix.service';
import SondageReponseService from '@/entities/sondage-reponse/sondage-reponse.service';
import MediaService from '@/entities/media/media.service';
import AffEvenementKiosqueService from '@/entities/aff-evenement-kiosque/aff-evenement-kiosque.service';
import AtelierService from '@/entities/atelier/atelier.service';
import AtelierPlaceService from '@/entities/atelier-place/atelier-place.service';
import SessionPresenceService from '@/entities/session-presence/session-presence.service';
import PresenceService from '@/entities/presence/presence.service';
import ParametreService from '@/entities/parametre/parametre.service';
import PriseParoleService from '@/entities/prise-parole/prise-parole.service';
import AffConferencierConferenceService from '@/entities/aff-conferencier-conference/aff-conferencier-conference.service';
import CnxConfigurationService from '@/entities/cnx-configuration/cnx-configuration.service';
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);

const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/forbidden');
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    userService: () => new UserManagementService(),

    auditsService: () => new AuditsService(),

    healthService: () => new HealthService(),

    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    alertService: () => alertService,
    translationService: () => translationService,
    userInfoService: () => new UserInfoService(),
    compteClientService: () => new CompteClientService(),
    evenementService: () => new EvenementService(),
    conferenceService: () => new ConferenceService(),
    inscriptionService: () => new InscriptionService(),
    participationService: () => new ParticipationService(),
    kiosqueService: () => new KiosqueService(),
    kiosqueVisiteService: () => new KiosqueVisiteService(),
    documentService: () => new DocumentService(),
    documentTelechargementService: () => new DocumentTelechargementService(),
    affRespCompteClientService: () => new AffRespCompteClientService(),
    affRespKiosqueService: () => new AffRespKiosqueService(),
    usagerService: () => new UsagerService(),
    adresseService: () => new AdresseService(),
    sondageService: () => new SondageService(),
    sondageQuestionService: () => new SondageQuestionService(),
    sondageChoixService: () => new SondageChoixService(),
    sondageReponseService: () => new SondageReponseService(),
    mediaService: () => new MediaService(),
    affEvenementKiosqueService: () => new AffEvenementKiosqueService(),
    atelierService: () => new AtelierService(),
    atelierPlaceService: () => new AtelierPlaceService(),
    sessionPresenceService: () => new SessionPresenceService(),
    presenceService: () => new PresenceService(),
    parametreService: () => new ParametreService(),
    priseParoleService: () => new PriseParoleService(),
    affConferencierConferenceService: () => new AffConferencierConferenceService(),
    cnxConfigurationService: () => new CnxConfigurationService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
  },
  i18n,
  store,
});
